var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "ContainerPage",
    { attrs: { title: "Flota Vehiculo" } },
    [
      _c(
        "v-card",
        { attrs: { flat: "", color: "transparent" } },
        [
          _c(
            "v-card-text",
            [
              _c("FilterFlotaVehiculo", {
                model: {
                  value: _vm.filter,
                  callback: function($$v) {
                    _vm.filter = $$v
                  },
                  expression: "filter"
                }
              }),
              _c(
                "v-flex",
                {
                  attrs: {
                    xs12: "",
                    sm5: "",
                    md3: "",
                    "offset-xs0": "",
                    "offset-lg10": ""
                  }
                },
                [
                  _c("v-text-field", {
                    attrs: {
                      "append-icon": "search",
                      label: "Buscar...",
                      "single-line": "",
                      "hide-details": ""
                    },
                    model: {
                      value: _vm.search,
                      callback: function($$v) {
                        _vm.search = $$v
                      },
                      expression: "search"
                    }
                  })
                ],
                1
              ),
              _c("FlotaVehiculoTable", {
                attrs: {
                  config: _vm.configTable,
                  dataTable: _vm.dataTable,
                  search: _vm.search
                }
              })
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }